module.exports = __webpack_public_path__ + "static/media/eva1.c3ed99c8.png";